import { getCurrentBoardId } from '../../reducers/currentBoardId/currentBoardIdSelector';

export const getDuplicateOriginalIdSelector = (state, ownProps) =>
    state.getIn(['app', 'duplications', ownProps.elementId]);

export const getDuplicateLoadingForCurrentBoard = (state) => {
    const currentBoardId = getCurrentBoardId(state);
    return state.getIn(['app', 'duplications', 'loading', currentBoardId, 'loading']);
};

export const getDuplicateLoadingForBoard = (state, ownProps) =>
    state.getIn(['app', 'duplications', 'loading', ownProps.elementId, 'loading']);

export const getDuplicatesLoading = (state) => state.getIn(['app', 'duplications', 'loading']);
